export const getTimeFilter = (timeFilter) => {
    if (timeFilter === "week") {
        return "WEEKLY";
    }
    else if (timeFilter === "month") {
        return "MONTHLY";
    }
    else {
        return "ALL TIME";
    }
};
export const getParticipantFilter = (participantFilter) => {
    switch (participantFilter) {
        case "individual":
            return "INDIVIDUAL OVERALL RANKING";
        case "team":
            return "TEAM OVERALL RANKING";
        case "average-combined":
            return "AVERAGE RANKING";
        case "combined":
        default:
            return "INDIVIDUAL AND TEAM OVERALL RANKING";
    }
};
